import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import PricingPage from '../PricingPage/PricingPage';
import PortfolioPage from '../PortfolioPage/PortfolioPage';
import PortfolioSinglePage from '../PortfolioSinglePage/PortfolioSinglePage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import ServicePage from '../ServicePage/ServicePage';
import ServicePageInner01 from '../ServicePage/ServicePageInner01';
import ServicePageInner02 from '../ServicePage/ServicePageInner02';
import ServicePageInner03 from '../ServicePage/ServicePageInner03';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import BlogPage from '../BlogPage/BlogPage';
import BlogDetails from '../BlogDetails/BlogDetails';
import ContactPage from '../ContactPage/ContactPage';

import TheDestiny from '../PortfolioSinglePage/the-destiny';
import NewBharat from '../PortfolioSinglePage/new-bharat';
import NinetyNinePointP from '../PortfolioSinglePage/ninety-nine-point-five-p';
import OneTen from '../PortfolioSinglePage/oneten';
import Goware from '../PortfolioSinglePage/goware';

import StudioPage from '../StudioPage/StudioPage';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="home_software_company" element={<HomePage2 />} />
          <Route path="home_business_consulting" element={<HomePage3 />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="portfolio_details/:slug" element={<PortfolioSinglePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team-single/:slug" element={<TeamSinglePage />} />
          <Route path="services" element={<ServicePage />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
		  <Route path="service-single/video-production-and-creative" element={<ServicePageInner01 />} />
		  <Route path="service-single/digital-marketing-and-branding" element={<ServicePageInner02 />} />
		  <Route path="service-single/photography-and-design" element={<ServicePageInner03 />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />
          <Route path="contact" element={<ContactPage />} />  
		  
		  
		  <Route path="/portfolio_details/the-destiny" element={<TheDestiny />} />
		  <Route path="/portfolio_details/new-bharat" element={<NewBharat />} />
		  <Route path="/portfolio_details/ninety-nine-point-five-p" element={<NinetyNinePointP />} />
		  <Route path="/portfolio_details/oneten" element={<OneTen />} />
		  <Route path="/portfolio_details/goware" element={<Goware />} />
		  
		  <Route path="studio" element={<StudioPage />} />
		  
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
